// KYC T4 — Capacitor camera bridge (native only, loaded on demand). The guided in-app camera runs in the WebView
// (getUserMedia) on every platform; this module only handles the OS permission, the gallery picker and the
// system-camera fallback when the WebView cannot open the camera.
import { isNativeApp } from "./platform";

const plugin = () => import("@capacitor/camera");

const toFile = async (webPath, name) => {
  const blob = await (await fetch(webPath)).blob();
  return new File([blob], name, { type: blob.type || "image/jpeg", lastModified: Date.now() });
};

// "granted" | "denied" | "limited" | "prompt" | "unknown" — asks the OS when still undecided.
export const nativeCameraPermission = async () => {
  if (!isNativeApp()) return "granted";
  try {
    const { Camera } = await plugin();
    let s = await Camera.checkPermissions();
    if (s.camera === "prompt" || s.camera === "prompt-with-rationale") s = await Camera.requestPermissions({ permissions: ["camera"] });
    return s.camera || "unknown";
  } catch { return "unknown"; }
};

// System camera app (fallback). null when the member cancels.
export const nativeTakePhoto = async () => {
  try {
    const { Camera } = await plugin();
    const r = await Camera.takePhoto({ quality: 92, correctOrientation: true, saveToGallery: false, editable: "no", webUseInput: true });
    return r?.webPath ? await toFile(r.webPath, "identity-camera.jpg") : null;
  } catch { return null; }
};

// Photo library (native). null when the member cancels.
export const nativePickPhoto = async () => {
  try {
    const { Camera, MediaTypeSelection } = await plugin();
    const r = await Camera.chooseFromGallery({ mediaType: MediaTypeSelection.Photo, allowMultipleSelection: false, quality: 92, correctOrientation: true, webUseInput: true });
    const m = r?.results?.[0];
    return m?.webPath ? await toFile(m.webPath, "identity-import.jpg") : null;
  } catch { return null; }
};
